// libs
import React, { memo } from 'react';

// styles
import { Container } from './styles';

// components
import Term from './Term';

// defs
import { ISuggestion } from 'shared/store/globalSearch/types';

// context
import { useKeyboardEventContext } from 'shared/components/GlobalSearch/components/KeyboardWrapper/KeyboardContext';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// defs
interface ISuggestionsProps {
  data: ISuggestion[];
  searchType: string;
  maxTrendingItems: number;
  maxRecentSearches: number;
  currentRecentSearchLength: number;
  onCategorySwitch?: (storeToRedirect: string, redirectUrl: string, productName: string) => void;
}

function Suggestions({
  data,
  searchType,
  maxTrendingItems,
  maxRecentSearches,
  currentRecentSearchLength,
  onCategorySwitch,
}: ISuggestionsProps) {
  const { currentIndex } = useKeyboardEventContext();
  const TrendingIcon = useStoreIcon(IconName.TREND_LINE);
  // ALl Terms
  const suggestions = data
    .slice(0, maxTrendingItems)
    .map((searchInfo: ISuggestion, indx: number) => {
      const suggestionValue = indx + currentRecentSearchLength;
      const isActive = suggestionValue === currentIndex;

      return (
        <Term
          key={'suggestion-' + indx}
          icon={<TrendingIcon />}
          searchType={searchType}
          searchInfo={searchInfo}
          active={isActive}
          value={suggestionValue}
          maxRecentSearches={maxRecentSearches}
          onCategorySwitch={onCategorySwitch}
        />
      );
    });

  return <Container data-test="Suggestions-container">{suggestions}</Container>;
}

export default memo(Suggestions);
